/**
 * Stable CSS class names for E2E — Cron builder UI.
 */
export const CRON = {
    root: 'cron-ui',

    frequencyControl: 'cron-ui-input__frequency-control',
    frequencyLabel: 'cron-ui-input__frequency-label',
    frequencySelect: 'cron-ui-input__frequency-select',
    frequencyOption: 'cron-ui-input__frequency-option',

    iteratedMinutesControl: 'cron-ui-input__iterated-minutes-control',
    iteratedMinutesInput: 'cron-ui-input__iterated-minutes',

    monthsControl: 'cron-ui-input__months-control',
    monthsLabel: 'cron-ui-input__months-label',
    monthsSelect: 'cron-ui-input__months-select',
    monthsOption: 'cron-ui-input__months-option',

    daysControl: 'cron-ui-input__days-control',
    daysLabel: 'cron-ui-input__days-label',
    daysSelect: 'cron-ui-input__days-select',
    daysOption: 'cron-ui-input__days-option',

    weekDaysControl: 'cron-ui-input__weekdays-control',
    weekDaysLabel: 'cron-ui-input__weekdays-label',
    weekDaysSelect: 'cron-ui-input__weekdays-select',
    weekDaysOption: 'cron-ui-input__weekdays-option',

    hoursControl: 'cron-ui-input__hours-control',
    hoursLabel: 'cron-ui-input__hours-label',
    hoursSelect: 'cron-ui-input__hours-select',
    hoursOption: 'cron-ui-input__hours-option',

    minutesControl: 'cron-ui-input__minutes-control',
    minutesLabel: 'cron-ui-input__minutes-label',
    minutesSelect: 'cron-ui-input__minutes-select',
    minutesOption: 'cron-ui-input__minutes-option',

    optionCheckbox: 'cron-ui-input__option-checkbox',
    optionText: 'cron-ui__option-text',

    previewRow: 'cron-ui__preview-row',
    previewText: 'cron-ui__preview-text',
    previewActions: 'cron-ui__preview-actions',
    clearButton: 'cron-ui-input--button-clear',
    clearIcon: 'cron-ui__clear-icon',
    copyButton: 'cron-ui-input--button-copy',
} as const;

export const cronCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

